<template>
  <div class="accessory-form">
    <accessory-select-vue
      accessory="standard"
      :machine="machineType"
      :echoList="props.accessoryList"
      :disabled="props.disabled"
      :ismobile="props.ismobile"
      ref="standardRef"
    ></accessory-select-vue>
    <accessory-select-vue
      accessory="optional"
      ref="optionalRef"
      :machine="machineType"
      :echoList="props.accessoryList"
      :disabled="props.disabled"
      :ismobile="props.ismobile"
    ></accessory-select-vue>
  </div>
</template>

<script>
import { defineComponent, ref, watch } from "vue";
import accessorySelectVue from "./accessorySelect.vue";

export default defineComponent({
  props: {
    machine: String,
    accessoryList: Array,
    disabled: Boolean,
    ismobile: Boolean,
  },
  components: {
    accessorySelectVue,
  },
  setup(props, context) {
    const machineType = ref(null);
    const standardRef = ref();
    const optionalRef = ref();
    // 检验数量
    const validateAccessory = () => {
      return new Promise((resolve, reject) => {
        let standardP = standardRef.value.validateSelectList();
        let optionalP = optionalRef.value.validateSelectList();

        Promise.all([standardP, optionalP])
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    };
    // 重置
    const resetAccessoryForm = () => {
      standardRef.value.resetSelect();
      optionalRef.value.resetSelect();
    };

    const setObjDateByList = (obj, list) => {
      list.forEach((item) => {
        obj[item.searchVal] = item.val;
      });
    };

    const getAccessory = () => {
      let obj = {};
      setObjDateByList(obj, standardRef.value.accessoryList);
      setObjDateByList(obj, optionalRef.value.accessoryList);

      return obj;
    };

    watch(
      () => props.machine,
      (val) => {
        if (val) {
          machineType.value = val.replace(/[^\u4E00-\u9FA5]/g, "");
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      machineType,
      standardRef,
      optionalRef,
      validateAccessory,
      resetAccessoryForm,
      getAccessory,
      props,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
